import React from 'react';
import FieldSelectionTop from './FieldSelectionTop';

const FieldSelectionTopContainer = () => {
  return <FieldSelectionTop />;
};

export default FieldSelectionTopContainer;
